import Link from 'next/link';
import React from "react";
// import "./style.scss";

function Contact(props) {
	const data = props?.contactPageData && props?.contactPageData.length ? props?.contactPageData[0] : null;
	// console.log(data);

	return (
		<>
			<div className="contactus">
				<div className="container">
					{/*<h1 className="text-center headingF headingF-sm">Contact Us</h1>*/}
					<h1 className="text-center headingF headingF-sm">{data?.page_title ?? ''}</h1>
					{/*<p className="text-center call-click"><a href="tel:(714)862-2926">CLICK TO CALL</a></p>*/}
					<p className="text-center call-click"><a href={data?.call_click?.link ?? ''}>{data?.call_click?.text ?? ''}</a></p>
					<div className="socail-links">
						{
							data?.social_links?.map((val,index)=>{
								return(
									<Link key={index} href={val.link}>
										<a target="_blank"><img src={val?.image_link} alt={val?.image_alt} /></a>
									</Link>
								)
							})
						}
						{/*<Link href="https://www.facebook.com/BayanClaremont">*/}
						{/*	<a target="_blank"><img src={`${process.env.IMAGES_BASE_URL}/static-content/fbook.png.webp`} alt="Facebook Icon" /></a>*/}
						{/*</Link>*/}
						{/*<Link href="https://twitter.com/BayanClaremont">*/}
						{/*	<a target="_blank"><img src={`${process.env.IMAGES_BASE_URL}/static-content/twitter.png.webp`} alt="Twitter Icon" /></a>*/}
						{/*</Link>*/}
						{/*<Link href="https://www.youtube.com/channel/UCQ9LjtTZ7G_UbkXzNRxrgyQ">*/}
						{/*	<a target="_blank"><img src={`${process.env.IMAGES_BASE_URL}/static-content/youtube.png.webp`} alt="Youtube Icon" /></a>*/}
						{/*</Link>*/}
						{/*<Link href="https://www.instagram.com/bayanclaremont/">*/}
						{/*	<a target="_blank"><img src={`${process.env.IMAGES_BASE_URL}/static-content/instagram.png.webp`} alt="Instagram Icon" /></a>*/}
						{/*</Link>*/}
						{/* <Link href="https://www.linkedin.com/company/bayan-islamic-graduate-school/"> */}
						{/* <a target="_blank"><img src={`${process.env.IMAGES_BASE_URL}/static-content/linkediniconpng.png`} alt="LinkedIn Icon" /></a> */}
						{/* </Link> */}
					</div>

					{/*<h2 className="sub-heading">Bayan Chicago<br></br>(Chicago Theological Seminary)</h2>*/}
					<h2 className="sub-heading"><span dangerouslySetInnerHTML={{ __html: data?.sub_heading }}></span></h2>
					{/*<p className="c-detail">As of Fall 2019, Bayan operates its degree programs at Chicago Theological Seminary (CTS), located in the Hyde Park area near the University of Chicago.</p>*/}
					<p className="c-detail">{data?.content ?? ''}</p>
					{/*<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2974.977837405691!2d-87.59323238482425!3d41.78569127917152!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880e29107b08ef77%3A0x4c0948d5d92cb4d2!2s1407%20E%2060th%20St%2C%20Chicago%2C%20IL%2060637%2C%20USA!5e0!3m2!1sen!2s!4v1598689927023!5m2!1sen!2s" width="600" height="450" frameBorder="0" style={{border:0}} aria-hidden="false" tab-index="0"></iframe>*/}
					<iframe src={data?.map_link} width="600" height="450" frameBorder="0" style={{border:0}} aria-hidden="false" tab-index="0"></iframe>
				</div>
			</div>
			
		</>
	);
}

export default Contact;
